import { tr } from 'date-fns/locale';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import verifyEmptyValues from '../../../../utils/verifyEmptyValues';

const ConvertObjectToArrayCreditDetails = (detailsArray) => {
  const {
    contestedparticipant,
    creationtime,
    documentIdPayer,
    documentIdReceiver,
    namePayer,
    nameReceiver,
    refundamount,
    refunddetails,
    refundreason,
    requestingparticipant,
    status,
    transactionid,
  } = detailsArray;

  const arrayPixTransaction = [
    {
      name: 'Data Registro',
      value: verifyEmptyValues(creationtime),
    },
    {
      name: 'Nome Pagador',
      value: verifyEmptyValues(namePayer),
    },
    {
      name: 'Documento Pagador',
      value: documentIdPayer?.length > 11 ? formatCNPJ(documentIdPayer) : formatCPF(documentIdPayer),
    },
    {
      name: 'Nome Recebedor',
      value: verifyEmptyValues(nameReceiver),
    },
    {
      name: 'Documento Recebedor',
      value: documentIdReceiver?.length > 11 ? formatCNPJ(documentIdReceiver) : formatCPF(documentIdReceiver),
    },
    {
      name: 'Valor',
      value: 'R$ ' + formatMoney(refundamount),
    },
    {
      name: 'Nuop',
      value: verifyEmptyValues(transactionid),
    },
    {
      name: 'Razão',
      value: verifyEmptyValues(refundreason),
    },
    {
      name: 'Status',
      value: verifyEmptyValues(status),
    },
    {
      name: 'Solicitante',
      value: verifyEmptyValues(requestingparticipant),
    },
    {
      name: 'Contestado',
      value: verifyEmptyValues(contestedparticipant),
    },
    {
      name: 'Detalhes',
      value: verifyEmptyValues(refunddetails),
    },
  ];

  return arrayPixTransaction;
};

export { ConvertObjectToArrayCreditDetails };
